import styled from 'styled-components'
import ArticleCard from '../ArticleCard';


const MultimediaGrid = styled("div")`
    display: grid;
    grid-template-columns: repeat(4, 1fr);
    grid-template-rows: repeat(2, 15vh);

    background: #959387;

    font-family: "Oswald", sans-serif;
    font-weight: 700;
    font-size: 48px;

    border: 1px solid black;
    line-height: 13vh;


    .MULTI {
        grid-row: 1;
        grid-column: 1;
        border: inherit;
        font-size:35px;
    }
    .M {
        grid-row: 1;
        grid-column: 2;
        border: inherit;

    }
    .E {
        grid-row: 1;
        grid-column: 3;
        border: inherit;

    }
    .D {
        grid-row: 2;
        grid-column: 2;
        border: inherit;
        border-bottom: 0px solid black;

    }
    .I {
        grid-row: 2;
        grid-column: 3;
        border: inherit;
        border-bottom: 0px solid black;

    }
    .A {
        grid-row: 2;
        grid-column: 4;
        border: inherit;
        border-bottom: 0px solid black;
    }

    .Blank1 {
        grid-row: 1;
        grid-column: 4;
        border: inherit;
        

    }
    .Blank2 {
        grid-row: 2;
        grid-column: 1;
        border: inherit;
        border-bottom: 0px solid black;
    }

`;

const ArticleGrid = styled("div")`
    background: #959387;
`

const BottomBorder = styled("div")`
    width: 100%;
    height: 1.5px;
    background: black;
`


const MultimediaMobile = (props) => {
    let a1 = props.multi[0];
    let a2 = props.multi[1];
    let a3 = props.multi[2];
    let a4 = props.multi[3];
    let a5 = props.multi[4];
    let a6 = props.multi[5];
    let a7 = props.multi[6];
    let a8 = props.multi[7];
    let a9 = props.multi[8];
    let a10 = props.multi[9];
    let a11 = props.multi[10];
    let a12 = props.multi[11];
    let a13 = props.multi[12];
    let a14 = props.multi[13];
    return (
        <>
            <MultimediaGrid>
                <div class="MULTI">MULTI</div>
                <div class="M">M</div>
                <div class="E">E</div>
                <div class="D">D</div>
                <div class="I">I</div>
                <div class="A">A</div>

                <div class="Blank1"></div>
                <div class="Blank2"></div>

            </MultimediaGrid>
<ArticleGrid>
            <div class="A1">
                <ArticleCard
                    position='right'
                    article_title={a1.article_title}
                    article_byline={a1.article_byline}
                    article_image={a1.article_image} article_url={a1.article_url}></ArticleCard>
            </div>
            <div class="A2">
                <ArticleCard
                    position='left'
                    article_title={a2.article_title}
                    article_byline={a2.article_byline}
                        article_image={a2.article_image} article_url={a2.article_url}></ArticleCard>
            </div>
            <div class="A3">
                <ArticleCard
                    position='right'
                    article_title={a3.article_title}
                    article_byline={a3.article_byline}
                        article_image={a3.article_image} article_url={a3.article_url}></ArticleCard>
            </div>
            <div class="A4">
                <ArticleCard
                    position='left'
                    article_title={a4.article_title}
                    article_byline={a4.article_byline}
                        article_image={a4.article_image} article_url={a4.article_url}></ArticleCard>
            </div>

                <div class="A1">
                    <ArticleCard
                        position='right'
                        article_title={a5.article_title}
                        article_byline={a5.article_byline}
                        article_image={a5.article_image} article_url={a5.article_url}></ArticleCard>
                </div>
                <div class="A2">
                    <ArticleCard
                        position='left'
                        article_title={a6.article_title}
                        article_byline={a6.article_byline}
                        article_image={a6.article_image} article_url={a6.article_url}></ArticleCard>
                </div>
                <div class="A3">
                    <ArticleCard
                        position='right'
                        article_title={a7.article_title}
                        article_byline={a7.article_byline}
                        article_image={a7.article_image} article_url={a7.article_url}></ArticleCard>
                </div>

                <div class="A1">
                    <ArticleCard
                        position='left'
                        article_title={a8.article_title}
                        article_byline={a8.article_byline}
                        article_image={a8.article_image} article_url={a8.article_url}></ArticleCard>
                </div>
                <div class="A2">
                    <ArticleCard
                        position='right'
                        article_title={a9.article_title}
                        article_byline={a9.article_byline}
                        article_image={a9.article_image} article_url={a9.article_url}></ArticleCard>
                </div>
                <div class="A3">
                    <ArticleCard
                        position='left'
                        article_title={a10.article_title}
                        article_byline={a10.article_byline}
                        article_image={a10.article_image} article_url={a10.article_url}></ArticleCard>
                </div>
                    <ArticleCard
                        position='right'
                        article_title={a11.article_title}
                        article_byline={a11.article_byline}
                    article_image={a11.article_image} article_url={a11.article_url}></ArticleCard>
                <div class="A2">
                    <ArticleCard
                        position='left'
                        article_title={a12.article_title}
                        article_byline={a12.article_byline}
                        article_image={a12.article_image} article_url={a12.article_url}></ArticleCard>
                </div>
                {<div class="A3">
                    <ArticleCard
                        position='right'
                        article_title={a13.article_title}
                        article_byline={a13.article_byline}
                        article_image={a13.article_image} article_url={a13.article_url}></ArticleCard>
                </div> }
                { <div class="A4">
                    <ArticleCard
                        position='left'
                        article_title={a14.article_title}
                        article_byline={a14.article_byline}
                        article_image={a14.article_image} article_url={a14.article_url}></ArticleCard>
                </div> }
            </ArticleGrid>
            <BottomBorder />
        </>
    )
}

export default MultimediaMobile;